import { render, staticRenderFns } from "./VideoItems1Template.vue?vue&type=template&id=18c7e8e6"
import script from "./VideoItems1Template.vue?vue&type=script&lang=js"
export * from "./VideoItems1Template.vue?vue&type=script&lang=js"
import style0 from "./VideoItems1Template.vue?vue&type=style&index=0&id=18c7e8e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports